/* Alessia Rose · ficha de producto: actualiza el "Ahorras X%" al cambiar de variante */
(function () {
  function update(variant) {
    var el = document.querySelector('[data-ar-save]');
    if (!el) return;
    var pctEl = el.querySelector('[data-ar-save-pct]');
    var cmp = variant && Number(variant.compare_at_price);
    var price = variant && Number(variant.price);
    if (cmp && price && cmp > price) {
      var pct = Math.floor(((cmp - price) * 100) / cmp);
      if (pct >= 1) {
        if (pctEl) pctEl.textContent = pct;
        el.hidden = false;
        return;
      }
    }
    el.hidden = true;
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      update(event && event.data && event.data.variant);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
